import type { CookieHelpers } from '@/utils/cookie';

function persistedTokens(): ReadonlyArray<string> {
	// A map hides same-name host/parent cookies. Inspect all copies before
	// normalizing them, since SDKs disagree on whether the first or last wins.
	return document.cookie.split(';').flatMap((entry) => {
		const cookie = entry.trim();
		if (!cookie.startsWith('at=')) return [];
		try {
			return [decodeURIComponent(cookie.slice(3))];
		} catch {
			return [];
		}
	});
}

/** Returns whether the native token replaced a different session. */
export function persistSession({
	cookies,
	token,
}: {
	cookies: CookieHelpers;
	token: string;
}): boolean {
	const previous = persistedTokens();
	if (previous.length > 0 && previous.every((value) => value === token))
		return false;
	// First check that writes work without deleting the fallback session. A
	// browser can silently deny cookie writes, not just throw an exception.
	cookies.setCookie('at', encodeURIComponent(token));
	cookies.syncCookies();
	if (!persistedTokens().includes(token))
		throw new Error('Native session cookie unavailable');
	// Clear host/parent shadows so the login SDK and cookie cache see the same
	// token. Only a DIFFERENT token invalidates the old web refresh/expiry pair.
	cookies.clearCookie('at');
	cookies.setCookie('at', encodeURIComponent(token));
	for (const key of ['atExpiresAt', 'rt', 'rtExpiresAt'])
		cookies.clearCookie(key);
	cookies.syncCookies();
	return true;
}
